import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = environment.jwtToken || localStorage.getItem('jwtToken');

  if (token && req.url.startsWith(environment.apiBaseUrls.gatewayBaseUrl)) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req);
};
